import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';

import articleReducer from './articleReducer';
import artisanReducers from './artisanReducers';
import authReducer from './authReducer';
import userReducers from './userReducers';

export default combineReducers({
  auth: authReducer,
  demands: articleReducer,
  users: userReducers,
  artisans: artisanReducers,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
});
